import React, { Component } from 'react';
import { Modal, message, Radio, Button } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const RadioGroup = Radio.Group;

class RemindWriteDate extends Component {
    state = {
        visible: false,
        record: {},
    }
    
    show = (record) => {
        this.setState({
            visible: true,
            record,
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            record: {},
        });
    };

    submit = () => {
        const { radioValue, record } = this.state;
        const { userRoleInvestigationSiteCrcId, roleId } = record;
        const { roleOptions = [], hideHourModal } = this.props;
        record.needRemindWriteDate = '0';
        if (radioValue == 'no') {
            const options = {
                method: 'POST',
                url: API_URL.manhour.setCrcNoNeedRemindWriteDate,
                data: {
                    userRoleInvestigationSiteCrcId,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.hide();
                    this.props.save(record);
                },
            };
            $.sendRequest(options);
        } else {
            const setSession = {};
            setSession.curRole = roleOptions.filter(el => el.roleId == roleId)[0].roleCode;
            const siteNameList = (record.investigationSiteName || '').split('-');
            const centerInfo = {
                ...record,
                investigationSiteCode: siteNameList[0],
                investigationSiteName: siteNameList[1],
            }
            this.setCenter(setSession, centerInfo);
            this.setSession(setSession);
            location.href = './#/member/crc';
            this.hide();
            if (hideHourModal)hideHourModal();
        }
    }

    setSession = (setSession) => {
        if (Object.keys(setSession).length !== 0) {
            for (let [k, v] of Object.entries(setSession)) {
                sessionStorage[k] = v;
            }
        }
    }

    setCenter = (setSession, item) => {
        setSession.invId = item.investigationId;
        setSession.invName = item.investigationName;
        setSession.investigationSiteCode = item.investigationSiteCode;
        setSession.investigationSiteName = item.investigationSiteName;
        setSession.siteId = item.investigationSiteId;
    };

    onRadioChange = (e) => {
        this.setState({ radioValue: e.target.value });
    }

    render () {
        const { visible, radioValue = '' } = this.state;
        return (
            <Modal
                title="授权时间确认提醒"
                visible={visible}
                closable={false}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
                footer={<Button type="primary" onClick={this.submit}>确定</Button>}
            >
                <div style={{ display: 'flex', flexDirection: 'column', padding: '10px 10px' }}>
                    
                        <div style={{ fontSize: 'small', marginBottom: 20, whiteSpace: 'normal', textIndent: '2em' }}>你作为项目CRC参与的启动后项目还未录入授权时间，请确认是否可以在项目内录入授权时间了？</div>
                        <div>
                            <RadioGroup
                                value={radioValue}
                                style={{marginLeft: 10, lineHeight: '28px'}}
                                onChange={this.onRadioChange}
                            >
                                <Radio value='yes'><span style={{ fontSize: 'small' }}>是，进入项目录入授权时间</span></Radio>
                                <Radio value='no'><span style={{ fontSize: 'small' }}>否</span></Radio>
                            </RadioGroup>
                        </div>
                        
                </div>
            </Modal>
        );
    }
}

export default RemindWriteDate;


// WEBPACK FOOTER //
// ./src/components/manHour/writeManhour/RemindWriteDate.js